import { SpacesFeature } from '@/shared/types/Settings';

export const getUpgradeAlertText = ({ enabled, metadata }: SpacesFeature) => {
  if (!enabled || !metadata?.user_limit) return 'Invite users to collaborate';

  return `Up to ${metadata?.user_limit} members available on your plan`;
};
